import axios from 'axios';

const API = (function() {
  var envUrl = process.env.REACT_APP_BACKEND_URL;
  var isSnap = typeof navigator !== 'undefined' && /ReactSnap|HeadlessChrome/i.test(navigator.userAgent || '');
  if (typeof window !== 'undefined' && envUrl) {
    if (isSnap) {
      // Durante react-snap: SIEMPRE usar el REACT_APP_BACKEND_URL, nunca el localhost del snapper
      return envUrl + '/api';
    }
    if (!envUrl.includes('localhost') && !envUrl.includes(window.location.hostname)) {
      return window.location.origin + '/api';
    }
  }
  return envUrl ? envUrl + '/api' : '/api';
})();

// Helper to get auth headers
const getAuthHeaders = () => {
  const token = localStorage.getItem('auth_token');
  return token ? { Authorization: `Bearer ${token}` } : {};
};

// Axios instance with auth
const authAxios = {
  get: (url, config = {}) => axios.get(url, { 
    ...config, 
    withCredentials: true,
    headers: { ...getAuthHeaders(), ...config.headers }
  }),
  post: (url, data, config = {}) => axios.post(url, data, { 
    ...config, 
    withCredentials: true,
    headers: { ...getAuthHeaders(), ...config.headers }
  }),
  put: (url, data, config = {}) => axios.put(url, data, { 
    ...config, 
    withCredentials: true,
    headers: { ...getAuthHeaders(), ...config.headers }
  }),
  delete: (url, config = {}) => axios.delete(url, { 
    ...config, 
    withCredentials: true,
    headers: { ...getAuthHeaders(), ...config.headers }
  })
};

export { authAxios, API, getAuthHeaders };
export default authAxios;
